import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Div from 'components/Div'
import { isLight } from 'tools/style'
import { typo, paddingSizes, borderRadiusSizes, colors, states, stateColors, stateThemes } from 'theme/default'

const fontWeights = typo.fontWeights

export const labelStates = states

const getStateThemes = (colorContainerColor) => {
  if (isLight(colorContainerColor)) {
    return stateThemes.dark
  } else {
    return stateThemes.light
  }
}

const getColor = (props, element) => {
  const theme = props.dynamic ? getStateThemes(props.theme.colorContainerColor) : stateThemes.dark
  return stateColors[element][props.state][theme]
}

const LabelContainer = styled(Div).attrs(() => ({
  paddingTop: paddingSizes.none,
  paddingBottom: paddingSizes.none,
  paddingLeft: paddingSizes.small,
  paddingRight: paddingSizes.small,
  borderRadius: borderRadiusSizes.small
}))`
  background-color: ${props => props.state ? getColor(props, 'backgroundColors') : colors.brandPrimary};
  border: 1px solid ${props => props.state ? getColor(props, 'borderColors') : colors.brandPrimary};
  color: ${props => props.state ? getColor(props, 'colors') : colors.container};
  font-weight: ${props => props.bold ? fontWeights.bold : fontWeights.regular};
  display: inline-block;
`
LabelContainer.propTypes = Div.propTypes

class Label extends React.PureComponent {
  static propTypes = {
    className: PropTypes.string,
    state: PropTypes.oneOf(Object.keys(labelStates)),
    dynamic: PropTypes.bool,
    bold: PropTypes.bool
  }

  static defaultProps = {
    bold: true
  }

  render () {
    const { children, className, state, dynamic, bold, ...props } = this.props
    return (
      <LabelContainer className={className} state={state} dynamic={dynamic} bold={bold} {...props}>
        {children}
      </LabelContainer>
    )
  }
}

export default Label
